<template>
  <div id="whats-new-modal" class="modal" :class="{'modal-fixed-footer': screenType === 'med-and-down'}">
    <div class="modal-content">

      <!-- Content begins here -->
      <div class="is-clipped">
        <div class="columns is-centered">
          <div class="column">
            <h4 class="is-title is-size-4 has-text-centered">COVID-19 UPDATE</h4>
          </div>
        </div>
        <div class="columns is-centered">
          <div class="column is-2">
            <div class="update-image">
              <img src="https://i.ibb.co/hZyJVbq/cv.jpg">
              <span class="img-courtesy is-pulled-left">Courtesy of the CDC</span>
            </div>
          </div>
          <div class="column is-10" style="overflow-y: auto;">

            <div class="content">
              <p>
                During this time of social distancing, we understand that TwoSeven plays a key role in connecting not just friends and family across the world, but even across neighboring blocks.
              </p>
              <p>
                TwoSeven is a free service, but we have some patron-only features to help us with our costs.
                To support you through this period of self-quarantine, we're giving away most features from existing patron tiers ($5, $10, and $20) for <b>$3</b> in a new patron tier - <i>social distancer</i>.
              </p>
              <p>
                We're incredibly grateful to be able to help provide you with the human connection that we all crave right now. You can also help brighten someone's lonely days by letting your friends know about TwoSeven.
              </p>
              <div class="columns is-centered" style="margin-top: 15px; margin-bottom: 15px">
                <div class="column is-half is-flex">
                  <div class="widget" v-if="!firstOpen">
                    <div class="fb-share-button fb-xfbml-parse-ignore" data-href="https://twoseven.xyz" data-layout="button_count" data-size="small" data-mobile-iframe="true">
                      <a class="fb-xfbml-parse-ignore" target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Ftwoseven.xyz%2F&amp;src=sdkpreparse">Share</a>
                    </div>
                  </div>
                  <div class="widget">
                    <a href="https://twitter.com/share?ref_src=twsrc%5Etfw" class="widget twitter-share-button" data-text="Stay connected during social distancing with TwoSeven - a webapp to watch videos from YouTube, Netflix, Hulu, Disney, Crunchyroll, etc with others---the next best thing to being together!" data-url="https://twoseven.xyz" data-via="twosevenxyz" data-show-count="false">
                      Tweet
                    </a>
                  </div>
                </div>
              </div>
              <p>
                Stay safe<br>
                The TwoSeven team
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End of content -->
    <div class="modal-footer">
      <button class="btn waves waves-effect waves-primary is-primary primary is-pulled-right" @click="closeModal">Close</button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AppBus from '@C/bus/app-bus.vue'
import Deferred from '@/js/deferred.js'

const localStorageKey = 'whats-new:last'

export default {
  name: 'room-options',
  computed: {
    ...mapGetters([
      'isRoom',
      'screenType'
    ])
  },
  data () {
    return {
      // NOTE: If you change this label, the modal will show up the next time a user logs in
      label: 'covid-19',
      ready: new Deferred(),
      firstOpen: true
    }
  },
  watch: {
    async '$route.name' (v) {
      this.checkRouteAndShowModal()
    }
  },
  methods: {
    hasSeenLabel () {
      if (localStorage.__testing__) {
        return true
      }
      const lastSeen = localStorage.getItem(localStorageKey)
      return lastSeen === this.label
    },
    openModal () {
      this.modal.open()
    },
    closeModal () {
      localStorage.setItem(localStorageKey, this.label)
      this.modal.close()
    },
    async checkRouteAndShowModal () {
      if (this.$route.name === 'roomPage') {
        await new Promise(resolve => AppBus.$once('sourceChange', resolve))
        await new Promise(resolve => setTimeout(resolve, 2000))
        if (!this.hasSeenLabel()) {
          await this.ready
          this.modal.open()
        }
      }
    }
  },
  async mounted () {
    this.modal = window.M.Modal.init(this.$el, {
      opacity: 0.7, // Opacity of modal background
      inDuration: 300, // Transition in duration
      outDuration: 200, // Transition out duration
      startingTop: '4%', // Starting top style attribute
      endingTop: '10%', // Ending top style attribute
      dismissible: false,
      onOpenStart: async () => {
        if (this.firstOpen) {
          setTimeout(() => {
            let script = document.createElement('script')
            script.src = 'https://platform.twitter.com/widgets.js'
            script.async = true
            document.head.appendChild(script)
            window.fbAsyncInit()
          }, 100)
          this.firstOpen = false
        }
        const setupDismiss = () => {
          const overlay = document.querySelector('.modal-overlay')
          this.overlay = overlay
          overlay.addEventListener('click', this.closeModal)
        }
        setTimeout(setupDismiss, this.hasSeenLabel() ? 0 : 3000)
      },
      onCloseStart: () => {
        try {
          this.overlay.removeEventListener('click', this.closeModal)
          delete this.overlay
        } catch (e) {
        }
      }
    })
    AppBus.$on('whats-new-open', this.openModal)
    this.ready.resolve()
    this.checkRouteAndShowModal()
  },
  beforeDestroy () {
    AppBus.$off('whats-new-open', this.openModal)
    this.modal.destroy()
  }
}
</script>

<style lang="scss" scoped>
.img-courtesy {
  margin-top: -4px;
  font-size: 0.6em;
}

.widget {
  margin: 0 12px;
}
</style>
